var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"p-4"},[_c('AgencySubscriptionForm',{on:{"close":_vm.goBack,"created":_vm.onCreated}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }